<template>
  <v-card class="pa-4 elevation-0 rounded-xl h-100-pct hover-shadow chart-membergrowth">
    <v-row>
      <v-col cols="12" class="pb-0">
        <div class="font-size-12 cl-grey font-weight-500">Informasi Rekening Bank <strong>Shines Beauty</strong></div>
      </v-col>
    </v-row>
    <v-row class="ml-0">
      <v-col class="pl-0" cols="12" sm="4" md="2" lg="2" v-for="(bank, idb) in accountList" :key="idb">
        <v-card class="brown lighten-5 elevation-0">
          <v-col cols="12" sm="12" md="12" class="d-flex align-center">
            <v-icon>mdi-bank</v-icon>
            <div class="cl-grey font-size-11 text-capitalize ml-2 font-weight-600">{{ bank.bank_name }}</div>
          </v-col>
          <v-col cols="12" sm="12" md="12" class="pt-0">
            <div class="font-size-10 secondary--text darken-5 font-weight-bold">{{ bank.accnum }}</div>
            <div class="font-size-10 primary--text font-weight-bold">{{ bank.name }}</div>
          </v-col>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>

export default {
  data() {
    return {
      accountList: [
        {
          name: 'Amelia Rosita Sanjaya',
          accnum: '0462483323',
          bank_name: 'BCA'
        },
        {
          name: 'Amelia Rosita Sanjaya',
          accnum: '592501027669533',
          bank_name: 'BRI'
        },
        {
          name: 'Amelia Rosita Sanjaya',
          accnum: '703953970900',
          bank_name: 'CIMB Niaga'
        },
        {
          name: 'Amelia Rosita Sanjaya',
          accnum: '1463868950',
          bank_name: 'BNI'
        },
        {
          name: 'Amelia Rosita Sanjaya',
          accnum: '1800011837442',
          bank_name: 'Mandiri'
        },
        {
          name: 'Amelia Rosita Sanjaya',
          accnum: '7207855752',
          bank_name: 'BSI'
        }
      ]
		}
  },
  props: {
    potency: Object,
  }
}
</script>